export enum EnvironmentType {
  Production = 'prod',
  Development = 'dev',
  Local = 'local',
  Demo = 'demo',
}
